import React from 'react';
// Utils
import { enumHelper } from '../../utils';
// Constants
import ENUMS from '../../enums';
import ShowForPermission from '../../components/ShowForPermission';

const renderStatusColors = status => {
  switch (status) {
    case 'OPEN':
      return 'text-info';
    case 'CLOSE':
      return 'text-scondary';
    case 'SUSPENDED':
      return 'text-warning';
    case 'STARTED':
      return 'text-info';
    case 'APPROVED':
      return 'text-success';
    default:
      return 'text-muted';
  }
};

export const incomingColumns = [
  {
    title: 'ردیف',
    isRowNumber: true
  },
  {
    title: 'نام کافه',
    dataIndex: 'cafeName',
    name: 'cafeName',
    isSortable: true,
    // permission: ENUMS.PERMISSIONS.values.VIEW_AHEAD_RESERVES_FOR_ADMIN
  },
  {
    title: 'درخواست‌دهنده',
    dataIndex: 'createdFullName',
    name: 'createdFullName',
    isSortable: true
  },
  {
    title: 'ساعت شروع رزرو',
    dataIndex: 'startAt',
    name: 'startAt',
    isSortable: true
  },
  {
    title: 'ساعت پایان رزرو',
    dataIndex: 'endAt',
    name: 'endAt',
    isSortable: true
  },
  {
    title: 'میزها',
    dataIndex: 'reservedTables',
    render: value => value?.map((ele, index, self) => ` ${ele.num} ${index < self.length - 1 ? '،' : ''}`)
  },
  {
    title: 'نوع رزرو',
    dataIndex: 'reserveType',
    name: 'reserveType',
    isSortable: true,
    render: reserveType => (
      <td className="text-center">
        {enumHelper.convertEnumValueToTitle(ENUMS.RESERVATION_TYPES.list, reserveType)}
      </td>
    )
  },
  {
    title: 'کد پیگیری',
    dataIndex: 'trackingNumber',
    name: 'trackingNumber',
    isSortable: true
  },
  {
    title: 'تعداد افراد',
    dataIndex: 'persons',
    name: 'persons',
    isSortable: true
  },
  {
    title: 'وعده غذایی',
    dataIndex: 'meal',
    render: meal => (
      <td className="text-center">
        {meal && meal.length && enumHelper.convertEnumValueToTitle(ENUMS.MEAL_PORTIONS.list, meal)}
      </td>
    ),
    name: 'meal',
    isSortable: true
  },
  {
    title: 'وضعیت',
    dataIndex: 'status',
    render: status => (
      <td className={`text-center ${renderStatusColors(status)}`}>
        {enumHelper.convertEnumValueToTitle(ENUMS.CAFE_RESERVATION.list, status)}
      </td>
    )
  },
  {
    title: 'بلاتکلیف',
    dataIndex: 'isSuspended',
    render: value =>
      value && (
        <span
          style={{ color: '#fa0', fontSize: '1.6rem' }}
          title={locales('messages.specify.suspended.reserve')}
        >
          &#9888;
        </span>
      )
  },
  {
    title: 'عملیات',
    action: (reserve, action) => (
      <>
        <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_RESERVE_DETAILS}>
          <a
            href="#"
            title={locales('titles.editIncomingReservation')}
            onClick={event => {
              event.preventDefault();
              action.displayReserveDetailsModal(reserve.id);
            }}
            className="text-center pointer"
          >
            <i className="text-center far fa-info-circle pointer" />
          </a>
        </ShowForPermission>
        {/* {(reserve.status == ENUMS.CAFE_RESERVATION.values.STARTED ||
          reserve.status == ENUMS.CAFE_RESERVATION.values.FINISHED) && (
          <a
            href="#"
            title={locales('titles.seeAndEditIncomingReserveFactor')}
            onClick={event => {
              event.preventDefault();
              action.displayInvoiceModal(reserve.id);
            }}
            className="text-center pointer mx-1"
          >
            <i className="text-center fal fa-receipt pointer" />
          </a>
        )} */}
      </>
    )
  }
];
